import React from 'react';
export function TopBar() {
  return <header className="w-full" data-id="element-85" data-mp="3sdwwj5gju7k5">
      <div className="mx-auto flex max-w-7xl items-baseline justify-between px-6 py-7 md:px-12 md:py-8 lg:px-24" data-id="element-86" data-mp="232ww1ivogms0">
        <a href="https://verawellnessco.com" className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-ink/60 transition-colors duration-200 ease-out hover:text-ink" data-id="element-87" data-mp="1y3ke9cjny5wa">
          ← Vera Wellness Co.
        </a>
        <a href="https://form.jotform.com/262156242446051" target="_blank" rel="noopener noreferrer" className="font-mono text-[10px] md:text-xs uppercase tracking-[0.3em] text-brass transition-colors duration-200 ease-out hover:text-ink" data-id="element-88" data-mp="2qrohlreri6vt">
          Apply
        </a>
      </div>
    </header>;
}